import {FirmaEntitiesState} from './firma-entities.state';
import {firmaEntitiesAdapter} from './firma-entities.adapter';


export const firmaEntitiesStateInitial: FirmaEntitiesState = firmaEntitiesAdapter.getInitialState({
  getLoading: [],
  getLoaded: [],
});
